import { TypeModel, MealRatio } from './../../../core/model/object/diet-model';
import { DietDayFoodLogsModel } from './../../../core/model/object/foodlog-model';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import {
  DietMealModel,
  DietsModel,
  DietDayModel,
} from 'src/app/core/model/object/diet-model';

@Injectable()
export class PlanShared {
  constructor() {}

  private _selectedDietDay: DietDayModel;
  private _selectedMeal: DietMealModel;
  private _selectedMealRatio: MealRatio;
  private _diets: DietsModel;
  private _selectedDietCalorie: number;
  private _dietType: TypeModel;
  private _dayStatus: string;
  private _selectedDietDayFoodLogs: DietDayFoodLogsModel;
  private _lockPlan: boolean;
  private _isDeeplink: boolean;

  saveRatios: Subject<number> = new Subject<number>();

  private removeCheatDayObs = new BehaviorSubject<boolean>(false);
  removeCheatDayObs$ = this.removeCheatDayObs.asObservable();

  private waterAddedObs = new BehaviorSubject<boolean>(false);
  waterAddedObs$ = this.waterAddedObs.asObservable();

  private refreshDietObs = new BehaviorSubject<boolean>(false);
  refreshDietObs$ = this.refreshDietObs.asObservable();

  private refreshMyPlanObs = new BehaviorSubject<boolean>(false);
  refreshMyPlanObs$ = this.refreshMyPlanObs.asObservable();

  private refreshDietDayObs = new BehaviorSubject<boolean>(false);
  refreshDietDayObs$ = this.refreshDietDayObs.asObservable();

  private showFirstTabObs = new BehaviorSubject<boolean>(false);
  showFirstTabObs$ = this.showFirstTabObs.asObservable();

  private showSecondTabObs = new BehaviorSubject<boolean>(false);
  showSecondTabObs$ = this.showSecondTabObs.asObservable();

  removeCheatDay() {
    this.removeCheatDayObs.next(true);
    this.removeCheatDayObs.next(false);
  }

  waterAdded() {
    this.waterAddedObs.next(true);
    this.waterAddedObs.next(false);
  }

  refreshDiet() {
    this.refreshDietObs.next(true);
    this.refreshDietObs.next(false);
  }

  refreshMyPlan() {
    this.refreshMyPlanObs.next(true);
    this.refreshMyPlanObs.next(false);
  }

  refreshDietDay() {
    this.refreshDietDayObs.next(true);
    this.refreshDietDayObs.next(false);
  }

  showFirstTab() {
    this.showFirstTabObs.next(true);
    this.showFirstTabObs.next(false);
  }

  showSecondTab() {
    this.showSecondTabObs.next(true);
    this.showSecondTabObs.next(false);
  }

  public get lockPlan(): boolean {
    return this._lockPlan;
  }
  public set lockPlan(value: boolean) {
    this._lockPlan = value;
  }

  public get selectedDietDayFoodLogs(): DietDayFoodLogsModel {
    return this._selectedDietDayFoodLogs;
  }
  public set selectedDietDayFoodLogs(value: DietDayFoodLogsModel) {
    this._selectedDietDayFoodLogs = value;
  }

  public get dayStatus(): string {
    return this._dayStatus;
  }
  public set dayStatus(value: string) {
    this._dayStatus = value;
  }

  public get selectedDietDay(): DietDayModel {
    return this._selectedDietDay;
  }
  public set selectedDietDay(value: DietDayModel) {
    this._selectedDietDay = value;
  }

  public get selectedMeal(): DietMealModel {
    return this._selectedMeal;
  }
  public set selectedMeal(value: DietMealModel) {
    this._selectedMeal = value;
  }

  public get selectedMealRatio(): MealRatio {
    return this._selectedMealRatio;
  }
  public set selectedMealRatio(value: MealRatio) {
    this._selectedMealRatio = value;
  }

  public get diets(): DietsModel {
    return this._diets;
  }
  public set diets(value: DietsModel) {
    this._diets = value;
  }

  public get selectedDietCalorie(): number {
    return this._selectedDietCalorie;
  }
  public set selectedDietCalorie(value: number) {
    this._selectedDietCalorie = value;
  }

  public get dietType(): TypeModel {
    return this._dietType;
  }
  public set dietType(value: TypeModel) {
    this._dietType = value;
  }

  public get isDeeplink(): boolean {
    return this._isDeeplink;
  }
  public set isDeeplink(value: boolean) {
    this._isDeeplink = value;
  }
}
